// @flow

import merge from 'lodash/merge';
import conf from './conf';
import ApiBase from './api-base';
import Logger from './logger';
import type { ApiConstructorArgsType } from '../types/api';

export default class Service {
  logger: Logger;
  conf: typeof conf;
  baseUrl: string;
  api: ApiBase;

  constructor(args: ApiConstructorArgsType = {}) {
    this.conf = merge({}, conf, args.conf);
    this.api = new ApiBase(args);
    this.logger = new Logger(args);
    this.baseUrl = this.conf.path.serviceBase;
  }
}
